import './components/subject_filter_form';
import './components/subject_list';
import './index.scss';
import 'components/chart/bar_chart';
import 'components/chart/pie_chart';
import 'components/empty_list_message';
import 'components/permission_overlay';
import 'components/summary_suggestions';
import 'pages/discipline/components/summary';
import zaraz from '../../utils/trackers/zaraz';

(function ($) {
  const $container = $('[data-event]');
  const eventData = $container.data('event') || {};

  const isSendEvent =
    eventData?.active && eventData?.zaraz_send_event && eventData?.event_props;

  if ($container && isSendEvent) {
    zaraz.set('show_experiment', 'true', { scope: 'persist' });
    zaraz.track(eventData.zaraz_event, eventData.event_props);
  }
})(jQuery);
